/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CostLaborByWorkerIdQueryFromJSON(json) {
    return CostLaborByWorkerIdQueryFromJSONTyped(json, false);
}
export function CostLaborByWorkerIdQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'laborWorkerId': !exists(json, 'laborWorkerId') ? undefined : json['laborWorkerId'],
        'laborDate': !exists(json, 'laborDate') ? undefined : (new Date(json['laborDate'])),
    };
}
export function CostLaborByWorkerIdQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'laborWorkerId': value.laborWorkerId,
        'laborDate': value.laborDate === undefined ? undefined : (value.laborDate.toISOString()),
    };
}
